<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/k6taNV/images/9780765351296.jpg?1727382215677" alt="This image is the cover for the book Building Harlequin's Moon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Building Harlequin's Moon
      </h1>
      <p class="bookDescription body article font2">
        <p>The first interstellar starship, John Glenn, fled a Solar System populated by rogue AIs and machine/human hybrids, threatened by too much nanotechnology, and rife with political dangers. The John Glenn's crew intended to terraform the nearly pristine planet Ymir, in hopes of creating a utopian society that would limit intelligent technology. <br/>But by some miscalculation they have landed in another solar system and must shape the gas giant planet Harlequin's moon, Selene, into a new, temporary home. Their only hope of ever reaching Ymir is to rebuild their store of antimatter by terraforming the moon. <br/>Gabriel, the head terraformer, must lead this nearly impossible task, with all the wrong materials: the wrong ships and tools, and too few resources. His primary tools are the uneducated and nearly-illiterate children of the original colonists, born and bred to build Harlequin's moon into an antimatter factory. <br/>Rachel Vanowen is one of these children. Basically a slave girl, she must do whatever the terraforming Council tells her.  She knows that Council monitors her actions from a circling vessel above Selene's atmosphere, and is responsible for everything Rachel and her people know, as well as all the skills, food, and knowledge they have ever received. With no concept of the future and a life defined with duty, how will the children of Selene ever survive once the Council is through terraforming and have abandoned Selene for its ultimate goal of Ymir?<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Niven, Brenda Cooper
      </h2>
      
      <p class="authorDescription body article"><P>LARRY NIVEN is the multiple Hugo and Nebula Award-winning author of the Ringworld series, along with many other science fiction masterpieces.  His Beowulf's Children, co-authored with Jerry Pournelle and Steven Barnes was a New York Times bestseller.  He lives in Chatsworth, California.<br><br>BRENDA COOPER has published many short stories, including a collaboration, Ice and Mirrors, with Larry Niven in Scatterbrain. She lives in Kirkland, Washington.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b516cf7e